import { useNavigate } from "react-router-dom";
import { Host_APIS } from "libs/apis/host.api";
import { successToaster } from "utils/helpers/common/alert-service";
import { RegisterRsvpDTO } from "utils/helpers/models/host-dtos/register-rsvp.dto";
import { useState } from "react";

const useHook = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<RegisterRsvpDTO[]>([]);

  const uploadProfile = async (params: FormData) => {
    const response = await Host_APIS.uploadFile(params);
    const { status = false, message = "", data = null } = response || {};

    if (status && data) {
      // successToaster(message);
      return data;
    }
  };

  const registerRsvp = async (body: RegisterRsvpDTO) => {
    const response = await Host_APIS.registerRsvp(body);
    const { status = false, message = "" } = response || {};

    if (status) {
      successToaster(message);
    }
  };

  // const getRsvpData = async () => {
  //   const response = await Host_APIS.getRsvpData();
  //   const { status = false } = response || {};

  //   if (status) {
  //     setData(response.data.content);
  //   }
  // };

  // Update RSVP by ID
  const updateRsvpByID = async (id: number, body: RegisterRsvpDTO) => {
    const response = await Host_APIS.updateRsvpById(id, body);
    const { status = false, message = "" } = response || {};

    if (status) {
      successToaster(message);
    }
  };

  const deleteRsvp = async (rsvpId: number) => {
      const response = await Host_APIS.deleteRsvp(rsvpId);
      const { status = false, message = "" } = response || {};

      if (status) {
        successToaster(message);
      } 
  };

  return {
    uploadProfile,
    registerRsvp,
    // getRsvpData,
    data,
    updateRsvpByID,
    deleteRsvp,
  };
};

export default useHook;
